import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RiesgosVialesTipoItem {
  id: number;
  descripcion: string;
  id_categoria: number;
  estado: number;
  fechacreacion?: string;
  fechamodificacion?: string;
}

export interface RiesgosVialesCategoriaItem {
  id: number;
  nombre_categoria: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
  tiposRiesgoViales?: RiesgosVialesTipoItem[];
}

@Injectable({ providedIn: 'root' })
export class RiesgosVialesCategoriasService {
  private apiUrl = `${environment.apiUrl}/api/riesgos_viales_categorias`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RiesgosVialesCategoriaItem[] | { data?: RiesgosVialesCategoriaItem[] }> {
    return this.http.get<RiesgosVialesCategoriaItem[] | { data?: RiesgosVialesCategoriaItem[] }>(this.apiUrl, {
      withCredentials: true,
    });
  }

  getById(id: number): Observable<RiesgosVialesCategoriaItem> {
    return this.http.get<RiesgosVialesCategoriaItem>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }
}